import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { ComparisonSection } from '../components/ComparisonSection';
import { WhyTokotetaSection } from '../components/WhyTokotetaSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { NewCTABanner } from '../components/NewCTABanner';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans text-text-main selection:bg-primary/20" data-id="element-329">
      <Header data-id="element-330" />
      <main data-id="element-331">
        <HeroSection data-id="element-332" />
        <ComparisonSection data-id="element-333" />
        <WhyTokotetaSection data-id="element-334" />
        <HowItWorksSection data-id="element-335" />
        <TestimonialsSection data-id="element-336" />
        <NewCTABanner data-id="element-337" />
      </main>
      <Footer data-id="element-338" />
    </div>;
}